import styled from "@emotion/styled";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #ffffff;
`;

export const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;
  padding: 0 1.5rem;
`;

export const Icon = styled.img`
  width: 1.5625rem;
  height: 1.25rem;
`;

export const EndContents = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d4d0f4;
  gap: 0.25rem;
`;

export const SendHintWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const SubText = styled.div`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
`;
